import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  imageUrl: null,
};

const imageModalSlice = createSlice({
  name: 'imageModal',
  initialState,
  reducers: {
    openImageModal(state, action) {
      state.isOpen = true;
      state.imageUrl = action.payload;
    },
    closeImageModal(state) {
      state.isOpen = false;
      state.imageUrl = null;
    },
  },
});

export const selectModalImageUrl = state => state.imageModal.imageUrl;
export const selectIsImageModalOpen = state => state.imageModal.isOpen;

export const { openImageModal, closeImageModal } = imageModalSlice.actions;

export default imageModalSlice.reducer;
